module.exports = __webpack_public_path__ + "static/media/23.042e9d65.png";